export { getRequestPeriods } from './shared';
import colors from '../assets/colors';
import { metricCards } from './webMetrics';

export const chartConfig = {
  colors: [colors.mainPallet[0], colors.mainPallet[3]],
  height: 260
};

export const widgetInfo = {
  'exposed-devices': 'Unique mobile sessions exposed during the selected period.',
  'website-visits': 'Distinct non-bot website sessions during the selected period.',
  'conversion-rate': 'Percentage of distinct matched MAIDs relative to distinct exposed MAIDs.',
  'exposed-devices-vs-website-visits': 'Comparison of exposed mobile sessions and website visits over time.',
  'top-landing-pages': 'Website sessions ranked by the first page visited.',
  'visits-by-sites': 'Distinct matched MAIDs grouped by attributed site.',
  'visits-by-day': 'Website sessions grouped by day.'
};

export const getInfo = id => JSON.stringify({ text: widgetInfo[id] });

export const getDailyWebsiteVisits = (response, timeZone) => {
  const websiteVisits = response?.timeSeries?.series?.find(series => series.key === 'website_visits');
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    timeZone
  });
  const points = (websiteVisits?.points || []).map(point => ({
    label: dateFormatter.format(new Date(point.timestamp)),
    value: Number(point.value)
  }));

  return {
    categories: points.map(point => point.label),
    data: [{ label: websiteVisits?.label || 'Website Visits', value: points }]
  };
};

export const getExposedDevicesVsWebsiteVisits = (response, timeZone) => {
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    timeZone
  });
  const series = response?.timeSeries?.series || [];
  const categories = series[0]?.points?.map(point => dateFormatter.format(new Date(point.timestamp))) || [];

  return {
    categories,
    data: series.map(item => ({
      label: item.label,
      value: (item.points || []).map(point => ({
        label: dateFormatter.format(new Date(point.timestamp)),
        value: Number(point.value)
      }))
    }))
  };
};

export const getScalarMetric = (metricId, response, previousResponse) => {
  const metric = metricCards.find(card => card.id === metricId);
  const label = metric?.title || metricId;

  return {
    ...metric,
    data: [{ label, value: Number(response?.scalar?.value || 0) }],
    previous: previousResponse ? [{ label, value: Number(previousResponse?.scalar?.value || 0) }] : undefined
  };
};

export const getTopSites = response =>
  (response?.categorySeries?.points || [])
    // The API denotes an unresolved site with both coordinates set to zero.
    .filter(point => Number(point.latitude) !== 0 || Number(point.longitude) !== 0)
    .map(point => ({
      id: point.key,
      displayName: point.label || point.key,
      latitude: point.latitude,
      longitude: point.longitude,
      maids: Number(point.value || 0)
    }));

export const getTopLandingPages = response =>
  (response?.categorySeries?.points || []).map(point => ({
    label: point.label || point.key,
    value: Number(point.value || 0)
  }));


export const webWidgets = {
  'exposed-devices': { ...metricCards[0], viewId: 'exposed_devices', display: 'digit', compare: true, webProperties: false },
  'website-visits': { ...metricCards[1], viewId: 'website_visits', display: 'digit', compare: true, webProperties: true },
  'conversion-rate': { ...metricCards[2], viewId: 'website_ip_match_conversion_rate', display: 'digit', webProperties: true },
  'exposed-devices-vs-website-visits': { title: 'Exposed Devices vs. Website Visits', display: 'line',
    viewId: 'exposed_signals_vs_website_visits', webProperties: true, config: chartConfig },
  'top-landing-pages': { title: 'Top Landing Pages', display: 'stats-list', viewId: 'website_top_landing_pages',
    webProperties: true, config: { height: 270 }, plotOptions: { displayBars: true } },
  'visits-by-sites': { title: 'Visits by Sites', display: 'map', viewId: 'website_ip_match_top_sites', webProperties: true },
  'visits-by-day': { title: 'Visits by Day', display: 'bar', viewId: 'exposed_signals_vs_website_visits',
    webProperties: true, config: { colors: [colors.mainPallet[0]], height: 245 } }
};

export const buildWebRequest = (definition, { portalId, period, webPropertyIds }) => ({
  scope: { brandPortalId: portalId }, period,
  ...(definition.webProperties ? { selection: { webPropertyIds } } : {})
});
